import type { FaireProductEntity } from "../../entity_types/product";

export const p_qcckwqm2xn: FaireProductEntity = {
  token: "p_qcckwqm2xn",
  type: "product",
  name: "Chicka Chicka Boom Boom by Bill Martin Jr.",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/5e5ff58ccb1ebc7aa9fb3b518379b314183edfc019763811c2f8633fd5677889.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/244e571558d918349028d575900ca05d113bef525f8950d736dceff9fa388428.jpeg",
    "https://cdn.faire.com/fastly/043e699254a77849e5ae850ee55608390d933cddc0a00c02ef2f44f43384849e.jpeg",
    "https://cdn.faire.com/fastly/30108ee6924fd20768a5b0d97da050a76dd9c7abf863f8331916c495fe5587fa.jpeg",
    "https://cdn.faire.com/fastly/c196e6999a1a53f30f4dcc5a4b02afc6a52567e7b39b21d7cba1575b55b44806.jpeg",
    "https://cdn.faire.com/fastly/bd8c468eedf98f94f11801b56d6eea220c19163985d860e9b4a7716b3f60cb9d.jpeg",
    "https://cdn.faire.com/fastly/cec1ba3bf6171fb48c02bc4dc646fbba4cca20447365730416e5b85da813ae10.jpeg",
    "https://cdn.faire.com/fastly/7c7c91111c854f674b6c374eb5eaba8d100ef24c25f01fc36f9530023e8cf52d.jpeg",
  ],
  priceDollars: 4,
  description:
    "[Little Simon]\r\n\r\nThis rollicking alphabet adventure has been a favorite read-aloud for thirty years—now it’s perfectly sized for little hands in this sturdy board book edition!\r\n\r\nA told B,\r\n and B told C,\r\n “I’ll meet you at the\r\n top of the coconut tree.”\r\n \r\nIn this cheerful ABC board book for toddlers, the letters of the alphabet race up the coconut tree in a bright, bouncy chant—until the tree can’t hold them all and they come tumbling down in a chicka chicka BOOM! BOOM! What happens next? Little readers will love finding out!\r\n \r\nWith bold, high-contrast art from Caldecott Honor–winning illustrator Lois Ehlert and joyful rhyming text by Bill Martin Jr. and John Archambault, Chicka Chicka Boom Boom is a read-aloud classic that introduces letter recognition and phonics in a fun, memorable way.\r\n \r\nPerfect for story time, preschool classrooms, baby gifts, and more, this classic children’s alphabet book is a must-have for every nursery bookshelf. \r\n \r\nAlso available as board books: ",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:10.798Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
